import { render, staticRenderFns } from "./ProfileDataData.vue?vue&type=template&id=359bb137&"
import script from "./ProfileDataData.vue?vue&type=script&lang=js&"
export * from "./ProfileDataData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports